function getYouTubeVideoId(data) {
  try {
    const parsedUrl = new URL(data);

    // Handle standard YouTube watch URLs
    if (parsedUrl.hostname.includes('youtube.com')) {
      if (parsedUrl.searchParams.has('v')) {
        return parsedUrl.searchParams.get('v');
      }

      // Handle /embed/VIDEO_ID or /v/VIDEO_ID
      const pathMatch = parsedUrl.pathname.match(/\/(embed|v)\/([^/?]+)/);
      if (pathMatch) {
        return pathMatch[2];
      }
    }

    // Handle youtu.be short links
    if (parsedUrl.hostname === 'youtu.be') {
      return parsedUrl.pathname.slice(1);
    }

    return null;
  } catch {
    return null;
  }
}

document.addEventListener("DOMContentLoaded", function() {
  const videoId = getYouTubeVideoId(youTubeUrl);

  const templateElement = document.getElementById('template');
  if (!templateElement) return console.error('Template element not found');

  const templateContent = templateElement.content;
  const elementInsideTemplate = templateContent.querySelector('#video-section');

  if (!elementInsideTemplate) {
    console.error('Element with ID "video-section" not found inside template');
    return;
  }

  elementInsideTemplate.setAttribute('data-video-id', videoId);
});
